import Vue from 'vue';
import Component from 'vue-class-component';
import ArrowBack from 'assets/icons/ArrowBack.svg';
import ArrowPrev from 'assets/icons/ArrowPrev.svg';

@Component({
  props: {
    path: {
      type: Array,
      required: true,
    },
    arrowBack: {
      type: Boolean,
      default: true,
    },
    isSpain: {
      type: Boolean,
      default: false,
    },
  },
})
export default class BreadCrumbComponent extends Vue {
  icons = {
    arrowBack: ArrowBack,
    arrowPrev: ArrowPrev,
  };

  goBack() {
    this.$router.go(-1);
  }
}
